export const RESPONSE_CYCLE = 500;
export const ANY_ORIGIN = "*";
export const EVENT_MANAGER_NAME = "contentstack-adv-post-message";

export * from "./errorMessages.constants";
